@for (widgetGroup of widgetGroups(); track widgetGroup; let groupIndex = $index) {
    <div [id]="widgetGroup.id"
        [class]="showAllSearchCriteria() || widgetGroup.shouldDisplay() ? '' : 'hiddenQuicksearchElement'">
        <p-panel [toggleable]="true"
                [hisPanelHelptext]="widgetGroup.helptext"
                [hisPanelHelptextSubtitle]="widgetGroup.label | hisUi">
            <ng-template pTemplate="header">
                <his-heading [level]="headingLevelWidgetTitle" [value]="widgetGroup.label | hisUi" />
            </ng-template>
            @for (widget of widgetGroup.widgets; track widget; let widgetIndex = $index) {
                <div>
                    <div [class]="showAllSearchCriteria() || widget.shouldDisplay() ? '' : 'hiddenQuicksearchElement'">
                        <his-search-form-widget
                            [widget]="widget"
                            [form]="form()"
                            [showErrors]="true"
                            [isFirstInputElement]="groupIndex === 0 && widgetIndex === 0">
                        </his-search-form-widget>
                    </div>
                </div>
            }
            <his-search-criteriagroup
                [group]="widgetGroup"
                [form]="form()"
                [widgetGroups]="widgetGroups()">
            </his-search-criteriagroup>
        </p-panel>
    </div>
}